import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { MaterialUIControllerProvider } from "context";
import { SnackbarProvider } from "notistack";
import { LinearProgress } from "@material-ui/core";
import "./assets/css/nucleo-svg.css";
import "./assets/css/nucleo-icons.css";
import "./assets/scss/argon-design-system.scss?v1.0.0";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import "./i18n";
import { LocalizationProvider } from "@mui/x-date-pickers";
import tr from 'date-fns/locale/tr';
import en from 'date-fns/locale/en-US';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider maxSnack={3}>
      <Suspense fallback={<LinearProgress color="primary" />}>
        <BrowserRouter>
          <MaterialUIControllerProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
            <App />
            </LocalizationProvider>
          </MaterialUIControllerProvider>
        </BrowserRouter>
      </Suspense>
    </SnackbarProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
